/**
 * Idle-time prefetch of the lazily routed workbench chunks.
 *
 * Workbenches load as route-level chunks (App.tsx): the first navigation to
 * each one otherwise stalls on fetch + parse behind the full-screen loading
 * fallback. Warming them once the shell goes idle makes every later mode
 * switch resolve from the module cache instantly. Chunks are pulled
 * sequentially so background parsing never competes with interaction.
 */
const WORKBENCH_CHUNKS: Array<() => Promise<unknown>> = [
    () => import('../modules/bim'),
    () => import('../modules/cad'),
    () => import('../modules/nurbs'),
    () => import('../modules/sketch'),
    () => import('../views/Home'),
];

export function prefetchWorkbenchChunks(): void {
    const whenIdle = (cb: () => void): void => {
        if (typeof requestIdleCallback === 'function') requestIdleCallback(() => cb());
        else window.setTimeout(cb, 1500);
    };
    whenIdle(() => {
        void (async () => {
            for (const load of WORKBENCH_CHUNKS) {
                try {
                    await load();
                } catch {
                    // A failed warm-up only costs latency, never correctness —
                    // the route retries the import on first navigation.
                }
            }
        })();
    });
}
